import React from 'react';
import { useToast } from '../Contexts/ToastContext';

const typeStyles: Record<string, React.CSSProperties> = {
  success: { borderLeft: '4px solid #28a745' },
  error: { borderLeft: '4px solid #dc3545' },
  info: { borderLeft: '4px solid #0d6efd' }
};

const ToastContainer: React.FC = () => {
  const { toasts, dismissToast } = useToast();
  return (
    <div style={{
      position: 'fixed',
      top: 16,
      right: 16,
      zIndex: 2000,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      maxWidth: '340px'
    }}>
      {toasts.map(t => (
        <div key={t.id} style={{
          background: '#fff',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
          padding: '12px 14px',
          borderRadius: 6,
          fontSize: '0.9rem',
          lineHeight: 1.3,
          cursor: 'pointer',
          ...typeStyles[t.type]
        }} onClick={() => dismissToast(t.id)}>
          <strong style={{ textTransform: 'capitalize' }}>{t.type}</strong>: {t.message}
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
